import { EntityName } from 'record-it-time-common/EntityName';
import { TimeTrackingConfiguration } from '../../../classes/entities/TimeTrackingConfiguration/timeTrackingConfigurationTypes';
import { useEntityDeleteHandler } from './useEntityDeleteHandler';
export function useTimeTrackingConfigurationDeleteHandler(timeTrackingConfiguration) {
  return useEntityDeleteHandler(EntityName.TimeTrackingConfiguration, timeTrackingConfiguration, _temp);
}
function _temp(activity) {
  return activity.id;
}